








import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SnackBar extends Vue {
  @Prop({ default: false }) isSnackBarActivated!: boolean;
  @Prop({ default: "" }) message!: string;
  @Prop({ default: 3000 }) ttl!: number;
  @Prop({ default: "buttonProduct" }) buttonStyle!: string;

  get timeoutMs(): number {
    return this.ttl;
  }

  startCloseTimer() {
    setTimeout(() => {
      this.$emit("cancel", false);
    }, this.timeoutMs);
  }

  @Watch("isSnackBarActivated")
  onIsActivatedChange(newVal: boolean) {
    this.isSnackBarActivated = newVal;
    if (newVal) {
      this.startCloseTimer();
    }
  }
}
